import { render, staticRenderFns } from "./cooperate-mark.vue?vue&type=template&id=60bcb101&scoped=true&"
import script from "./cooperate-mark.vue?vue&type=script&lang=js&"
export * from "./cooperate-mark.vue?vue&type=script&lang=js&"
import style0 from "./cooperate-mark.vue?vue&type=style&index=0&id=60bcb101&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bcb101",
  null
  
)

export default component.exports